// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__PuQyW","logged":"Avatar_logged__dQesc","abbrevation":"Avatar_abbrevation__wMT7K","guest":"Avatar_guest__DgaSw"};